import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace EmailFields {
  export enum EmailField {
    Template = 'Email.Template',
    From = 'Email.From',
    Bcc = 'Email.Bcc',
    MoreInfo = 'Email.MoreInfo',
    AttachmentSizeLimit = 'Email.AttachmentSizeLimit',
  }

  export enum ViewField {
    AllViews = 'EmailView.AllViews',
  }

  export enum LegalHoldNotificationsField {
    LegalHoldNotificationsUsers = 'LegalHoldNotificationsUsers',
    LegalHoldNotificationsGroups = 'LegalHoldNotificationsGroups',
    LegalHoldNotificationsOffset = 'LegalHoldNotificationsOffset',
  }
}

class EmailConfig extends SettingsSubModule {
  @SettingsSubModule.value(EmailFields.EmailField.Template, '') template: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.EmailField.From, '') from: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.EmailField.Bcc, '') bcc: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.EmailField.MoreInfo, '') moreInfo: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.EmailField.AttachmentSizeLimit, 10) attachmentSizeLimit: SettingValue<number>;
}

class ViewConfig extends SettingsSubModule {
  @SettingsSubModule.value(EmailFields.ViewField.AllViews, '') allViews: SettingValue<string>;
}

class LegalHoldNotificationsConfig extends SettingsSubModule {
  @SettingsSubModule.value(EmailFields.LegalHoldNotificationsField.LegalHoldNotificationsUsers, '')
  legalHoldNotificationsUsers: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.LegalHoldNotificationsField.LegalHoldNotificationsGroups, '')
  legalHoldNotificationsGroups: SettingValue<string>;
  @SettingsSubModule.value(EmailFields.LegalHoldNotificationsField.LegalHoldNotificationsOffset, 3)
  legalHoldNotificationsOffset: SettingValue<number>;
}

export class EmailModule extends SettingsModule {
  @SettingsModule.value(EmailConfig) email: EmailConfig;
  @SettingsModule.value(ViewConfig) view: ViewConfig;
  @SettingsModule.value(LegalHoldNotificationsConfig) legalHoldNotifications: LegalHoldNotificationsConfig;
}
